<template>
  <div class="detail" style="margin: 0 auto">
    <div class="back" @click="router.push('/qualificationManage/index')">
      <a-button type="primary"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
    </div>

    <div class="head">
      <div class="inp-item">
        <div class="flex mb16">
          <div style="margin-left: 16px">
            测试类型
            <a-select v-model:value="form.category" @change="changeTestType" class="inp ml16" placeholder="请选择">
              <template v-for="item in testType" :key="item.dataCode">
                <a-select-option :value="item.dataCode">{{
                    item.dataValue
                  }}</a-select-option>
              </template>
            </a-select>
          </div>
          <div class="ml32">
            测试车辆信息
<!--            <a-select class="inp ml16" v-model:value="form.displayCarInfo" show-search placeholder="请输入车架号/测试牌照"-->
<!--                      :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"-->
<!--                      :options="data" @search="handleSearch" @change="handleChange"></a-select>-->
            <!-- <a-input class="inp ml16" placeholder="请输入车架号/测试牌照" v-model:value="form.displayCarInfo"></a-input> -->
            <a-input
              class="inp ml16"
              placeholder="请点击选择车辆"
              v-model:value="form.displayCarInfo"
              readonly
              @click="openCarSelectModal"
            />

          </div>
        </div>
        <div class="flex mb16">
          <div style="margin-left: 16px">
            测试区域
            <a-select v-model:value="form.zoneRelList" mode="multiple" class="inp ml16" @change="changeArea"
                      placeholder="请选择">
              <template v-for="item in zoneList" :key="item.id">
                <a-select-option :value="item.id">{{
                    item.name
                  }}</a-select-option>
              </template>
            </a-select>
          </div>
          <div class="ml32" style="margin-left: 65px">
            测试路线
            <mySelectAll :list="lines" :oldValue="form.line" ref="linesRef" />
          </div>
        </div>
        <div class="flex mb16">
          <div>
            测试有效期
            <a-range-picker class="inp ml16" v-model:value="form.validityTime" format="YYYY-MM-DD"
                            valueFormat="YYYY-MM-DD" @change="changeValidityTime" />
          </div>
          <div style="margin-left: 65px">
            <!-- 测试牌照
                        <a-input class="inp ml16" placeholder="请输入" v-model:value="form.plateNumber"></a-input> -->
          </div>
        </div>
        <div class="flex mb16">
          <div>
            关联驾驶员
            <mySelectAll :myAjax="getPersonListByCondition" :query="{ personType: 'driver', status: 1 }"
                         :oldValue="form.driver" ref="driverRef" />
          </div>
          <div class="ml32" style="margin-left: 51px">
            关联安全员
            <mySelectAll :myAjax="getPersonListByCondition" :query="{ personType: 'security', status: 1 }"
                         :oldValue="form.safety" ref="securityRef" />
          </div>
        </div>
      </div>
    </div>
    <div class="border"></div>

    <div class="center">
      <!-- <div class="tab_two_title" style="margin-top: 32px">
        示范区应急预案方案
      </div>
      <a class="file_text" :href="fileURL" target="_blank">
        <div></div>
        <div v-if="fileURL">
          <FileTextOutlined class="file_icon mr16" />
          {{ fileURLName }}
          <a>{{ getFileName(fileURL) }}</a>
        </div>
        <div v-else>
          <a>{{ fileURLName }}</a>
        </div>
        <div>
          <i class="iconfont icon-quanbuxiazaiicon" style="color: rgba(24, 111, 242, 1)"></i>
        </div>
      </a>
      <div class="border_update"></div>  -->
      <div class="tab_two_title" style="margin: 34px 0 24px 0">
        本申请所需材料清单
      </div>

      <div class="table">
        <fileTable :type="form.category" :data="fileData" :add="route.query.type == 'add'" :id="route.query.id"
                   ref="fileTableRef" />
      </div>

      <div class="mt50 botmBtn">
        <a-button type="primary" ghost @click="cancel">取消</a-button>
        <a-button type="primary" class="ml60" :disabled="confirmDisabled" @click="confirm">确定</a-button>
      </div>
    </div>
    <car-select-modal
      ref="carSelectModalRef"
      @selectedEvent="handleCarSelectConfirm"
      @cancelEvent="() => {}"
    />

  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  defineComponent,
  watch,
  nextTick,
  onUnmounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import fileTable from "./components/fileTable.vue";
import mySelectAll from "@/components/selectAll/index.vue";
import {
  getZoneList,
  getListByZoneType,
  getListByCondition,
  getPersonListByCondition,
  getZoneDetailTreeByType,
  checkTestDate,
  checkTestType,
  qualificationAdd,
  selectListByNum,
  getQualificationInfoDetail,
  getMaterialList,
  qualificationEdit,
} from "@/api/qualification/index";
import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
import { message } from "ant-design-vue";
import carSelectModal from "./components/carSelectModal.vue";

const router = useRouter();
const route = useRoute();
const appStore = useAppStore();

const userStore = useUserStore();

const form = ref({
  category: "",
  displayCarInfo: null,
  zoneRelList: [],
  line: [],
  validityTime: [],
  driver: [],
  safety: [],
});

function changeTestType(val) {
  getMaterialListFn(val);
  getAreaLines(val);
  form.value.zoneRelList = [];
  form.value.line = [];
}

//车辆信息
let timeout;
let currentValue = "";
let cars = ref([]);
function fetch(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  function fake() {
    selectListByNum({ num: value }).then((res) => {
      if (currentValue === value) {
        const result = res.data;
        const data = [];
        result.forEach((r) => {
          data.push({
            value: r.id,
            label: r.frameNum + "/" + r.testCarNum || "无",
          });
        });
        cars.value = data;
        console.log(111, data);
        callback(data);
      }
    });
  }
  timeout = setTimeout(fake, 300);
}
const data = ref([]);
let carId = ref();
const handleSearch = (val) => {
  fetch(val, (d) => (data.value = d));
};
const handleChange = (val, item) => {
  form.value.displayCarInfo = item.label;
  carId.value = item.value;

  fetch(val, (d) => (data.value = d));
};

// 添加车辆选择模态框相关代码
const carSelectModalRef = ref(null);


// 打开车辆选择弹框
const openCarSelectModal = () => {
  if (carSelectModalRef.value) {
    carSelectModalRef.value.showModal();
  }
};

// 处理车辆选择确认
const handleCarSelectConfirm = (selectedCar) => {
  form.value.displayCarInfo = `${selectedCar.frameNum}/${selectedCar.testCarNum || '暂无测试牌照'}`;
  carId.value = selectedCar.id;
};

//区域
const zoneList = ref([]);

//材料清单
const fileData = ref([]);
function getMaterialListFn(val) {
  getListByCondition({ funcCode: "qualification_material_" + val }).then(
      (res) => {
        if (res.code == 200) {
          console.log(res.data);
          fileData.value = res.data;
        }
      }
  );
  console.log("***********************");
}

const getFileName = (url) => {
  if (url) {
    let arr = url?.split("/");
    let file = arr[arr.length - 1];
    return file.split(".")[0];
  }
};

//示范区应急预案方案 文件
const fileURL = ref();
const fileURLName = ref();
function geFileFn() {
  getListByCondition({ funcCode: "qualification_emergency_plan" }).then(
      (res) => {
        if (res.code == 200) {
          fileURL.value = res.data[0]?.url;
          fileURLName.value = res.data[0]?.displayName;
        }
      }
  );
}

//获取区域 线路  val  测试类型
function getAreaLines(val) {
  return new Promise((resolve, reject) => {
    getZoneDetailTreeByType({ testType: val }).then((res) => {
      if (res.code == 200) {
        console.log(res.data, "获取区域线路数据");
        zoneList.value = res.data;
        resolve(res.data); // 解析 Promise
      } else {
        reject("获取区域线路数据失败"); // 拒绝 Promise
      }
    });
  });
}
const lines = ref([]);
function changeArea(val) {
  let arr = [];
  console.log(val, 11, zoneList.value);
  zoneList.value?.map((item) => {
    if (val.includes(item.id)) {
      arr.push(...item.childrens);
    }
  });

  if (arr.length) {
    lines.value = arr;
  } else {
    form.value.line = [];
  }
  console.log(lines.value, 21);
}

function changeValidityTime(val) {
  form.value.validityTime = val;
  console.log(form, val);
}

const confirmDisabled = ref(false)
const checkDate = ref(true)
const checkType = ref(true)
function checkQualification() {
  let info = {
    carFrameNum: form.value.displayCarInfo.split("/")[0],
    carNum: form.value.displayCarInfo.split("/")[1],
    endDate: form.value.validityTime[1],
    startDate: form.value.validityTime[0],
    testType: form.value.category,
    carId: carId.value
  };
  checkTestDate(info).then((res) => {
    checkDate.value = res.data.result
    if (!res.data.result) {
      console.log(223);
      message.error(res.data.msg);
    }
  });
}

function checkTestTypeFn() {
  let info = {
    carFrameNum: form.value.displayCarInfo.split("/")[0],
    carNum: form.value.displayCarInfo.split("/")[1],
    testType: form.value.category,
    carId: carId.value
  };
  checkTestType(info).then((res) => {
    checkType.value = res.data.result
    if (!res.data.result) {
      message.warning(res.data.msg ? res.data.msg : '超出有效期');
    }
  });
}

watch(
    () => [form.value.category, form.value.displayCarInfo],
    (newValues, oldValues) => {
      // 只有当所有二个依赖项都有值时，才执行 checkTestTypeFn
      const [category, displayCarInfo] = newValues;
      if (category && displayCarInfo) {
        checkTestTypeFn();
      }
    },
    { deep: true }
);

watch(
    () => [
      form.value.category,
      form.value.validityTime,
      form.value.displayCarInfo,
    ],
    (newValues, oldValues) => {
      // 只有当所有三个依赖项都有值时，才执行 checkQualification
      const [category, validityTime, displayCarInfo] = newValues;
      if (category && validityTime.length > 0 && displayCarInfo) {
        checkQualification();
      }
    },
    { deep: true }
);

const linesRef = ref();
const securityRef = ref();
const driverRef = ref();
let fileTableRef = ref();

//新增保存
function confirm() {
  if (form.value.displayCarInfo === "" || form.value.displayCarInfo === null) {
    message.error("请填写车辆信息");
    return false;
  } else if (form.value.zoneRelList.length === 0) {
    message.error("请选择测试区域");
    return false;
  } else if (linesRef.value.valueList.length === 0) {
    console.log(linesRef.value.valueList.length);
    message.error("请选择测试路线");
    return false;
  } else if (form.value.validityTime.length === 0) {
    message.error("请选择测试有效期");
    return false;
  } else if (driverRef.value.valueList.length === 0) {
    message.error("请选择关联驾驶员");
    return false;
  } else if (securityRef.value.valueList.length === 0) {
    message.error("请选择关联安全员");
    return false;
  }

  if(form.value.category, form.value.displayCarInfo){
    checkTestTypeFn();
    if (!checkType.value) {
      return false;
    }
  }

  if (form.value.category && form.value.validityTime.length > 0 && form.value.displayCarInfo) {
    checkQualification();
    if (!checkDate.value) {
      return false;
    }
  }


  let carInfo = {};
  console.log(cars.value, 45454);

  let zoneRelList = [];
  let lines = linesRef.value.valueList;
  // let linesLabel=linesRef.value.labelList;
  // form.value.zoneRelList
  zoneList.value.map((item) => {
    item.childrens.map((child) => {
      console.log(lines.includes(child.id));
      if (lines.includes(child.id)) {
        zoneRelList.push({
          zoneDetailId: child.id,
          zoneDetailName: child.name,
          zoneId: item.id,
          zoneName: item.name,
          zoneType: child.type,
        });
      }
    });
  });
  // console.log(lines,'2222222222222222222222222222222');
  // console.log(zoneList.value,'1111111111111111111111111111111111');
  let security = securityRef.value.valueList;
  let securityLabel = securityRef.value.labelList;
  let driver = driverRef.value.valueList;
  let driverLabel = driverRef.value.labelList;
  // 创建一个新的数组，包含 security 和 driver 中所有的元素，重复的元素只会出现一次
  let union = [...new Set([...security, ...driver])];

  let personRels = union.map((personId) => {
    let qualificationPersonType = "";
    let personName = "";
    if (security.includes(personId)) {
      qualificationPersonType += "security";
      // 找到 security 中 personId 对应的标签
      let index = security.indexOf(personId);
      if (index !== -1) {
        personName = securityLabel[index];
      }
    }
    if (driver.includes(personId)) {
      qualificationPersonType += qualificationPersonType ? ",driver" : "driver";
      // 找到 security 中 personId 对应的标签
      let index = driver.indexOf(personId);
      if (index !== -1) {
        personName = driverLabel[index];
      }
    }
    return {
      personName,
      personId,
      qualificationPersonType,
    };
  });

  //材料清单列表  新增
  let materialList = [];
  fileTableRef.value.dataSource.map((item) => {
    materialList.push({
      materialTemplateFile: item.url,
      materialTemplateId: item.id,
      materialTemplateName: item.displayName,
      uploadFile: item.uploadFile,
      sort: item.sort,
    });
  });
  console.log(materialList);

  let info = {
    deptId: userStore.deptId,
    deptName: userStore.deptName,
    carId: carId.value,
    category: form.value.category,
    displayCarInfo: form.value.displayCarInfo,
    testStartTime: form.value.validityTime[0],
    testEndTime: form.value.validityTime[1],
    zoneRelList: zoneRelList,
    personRels: personRels,
  };

  if (route.query.id) {
    //存在id  走编辑接口
    edit(info);
    return false;
  } else {
    info.materialList = materialList;
  }

  console.log(info);
  qualificationAdd(info).then((res) => {
    if (res.code == 200) {
      message.success("新增成功!");
      router.push("/qualificationManage/index");
    } else {
      message.error(res.msg);
    }
  });
}

const cancel = () => {
  router.push("/qualificationManage/index");
};

const testType = ref([]);

const ws = ref(null);
const connectWS = () => {
  if ("WebSocket" in window) {
    let tid = userStore.id + "_" + route.query.id;
    console.log("您的浏览器支持WebSocket");
    let url = "";
    console.log(process.env, process.env.VUE_APP_WS_URL);
    if (process.env.VUE_APP_ENV == "development") {
      console.log(window.location);
      url = process.env.VUE_APP_WS_URL + "/ws/" + tid;
    } else {
      url = "ws://" + window.location.host + "/ws/" + tid;
      //   url = window.location.origin + "/ws/" + tid;
    }

    ws.value = new WebSocket(url);

    ws.value.onopen = function () {
      console.log('连接成功');
      // ws.value.send("hello");
    };
    ws.value.onmessage = function (e) {
      let data = JSON.parse(e.data);
      console.log(data);
      if (data.msgType === 'QUALIFICATION_MATERIAL_CHECK_START') {
        if (data.msgData.Auditing) {
          message.warning("此申请正在审批中，不可修改！");
          setTimeout(() => {
            router.push("/qualificationManage/index");
          }, 3000);
        }
      }

    };
    ws.value.onclose = function (e) {
      console.log("close", e);
    };
    ws.value.onerror = function (e) { };
  } else {
    console.log("您的浏览器不支持WebSocket");
  }
};

//编辑相关

if (route.query.id) {
  console.log(123);
  getDetail();
  // getMaterials();
  // getResule()
  connectWS();
}

async function getDetail() {
  try {
    const detailResponse = await getQualificationInfoDetail({
      id: route.query.id,
    });
    let data = detailResponse.data;
    form.value.category = data.category;
    form.value.displayCarInfo = data.displayCarInfo;
    form.value.validityTime = [data.testStartTime, data.testEndTime];

    // 等待 getAreaLines 函数完成
    await getAreaLines(form.value.category);
    console.log(zoneList.value, "区域线路列表");

    let zone = [],
        lines = [];
    data.zoneRelList.forEach((item) => {
      zone.push(item.zoneId);
      lines.push(item.zoneDetailId);
    });
    form.value.zoneRelList = [...new Set(zone)];
    changeArea(form.value.zoneRelList); //获取对应的线路
    form.value.line = [...new Set(lines)];
    console.log(form.value, "表单值");
    getMaterials();
    getDriver_security(data.personRels);
  } catch (error) {
    console.error(error);
  }
}

//关联驾驶员、安全员 回显
function getDriver_security(list) {
  let arr = [],
      arr2 = [];
  list?.map((item) => {
    if (item.qualificationPersonType.indexOf("driver") > -1) {
      arr.push(item.personId);
    }
    if (item.qualificationPersonType.indexOf("security") > -1) {
      arr2.push(item.personId);
    }
  });
  form.value.driver = arr;
  form.value.safety = arr2;
}

function getMaterials() {
  getMaterialList({ qualificationsId: route.query.id }).then((res) => {
    fileData.value = res.data;
  });
}

function getResule() {
  getQualificationCheckResults({ id: route.query.id }).then((res) => {
    // resultDataSource.value = res.data;
  });
}

let againUpdate = ref(false); ///普通编辑  ，   true 若为再次提交申请（材料不通过被打回时），againUpdate传true
if (route.query.againUpdate) {
  againUpdate.value = true;
}

//编辑保存
function edit(info) {
  let data = {
    ...info,
    id: route.query.id,
  };
  if (againUpdate.value) {
    data.againUpdate = true;
  }
  console.log(data);
  // return false;
  qualificationEdit(data).then((res) => {
    if (res.code == 200) {
      message.success("保存成功!");
      router.push("/qualificationManage/index");
    } else {
      message.error(res.msg);
    }
  });
}

onMounted(async () => {
  //获取测试类型字典数据
  testType.value = await appStore.getSysDictVOList("测试类型");
  geFileFn();
  //初始化选中一个，获取材料清单
  if (!route.query.id) {
    form.value.category = testType.value[0].dataCode;
    getMaterialListFn(form.value.category);
    getAreaLines(form.value.category);
  }
});

onUnmounted(() => {
  if (ws.value) {
    ws.value.close();
  }
});
</script>
<style lang="less" scoped>
.detail {
  padding: 20px 45px 37px 45px;
  // height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
  // display: flex;
  // justify-content: center;
  // align-items: center;

  .back {
    position: fixed;
    top: 93px;
    right: 50px;
  }
}

.head {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .inp-item {
    width: 70%;

    .flex {
      justify-content: space-between;
    }
  }
}

.border {
  margin-top: 35px;
  margin-bottom: 24px;
  border: 1px solid #d9e5f4;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.tab_two_title {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  margin: 28px 0 24px 0;
  position: relative;
  padding-left: 10px;
  width: 70%;

  &::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 13px;
    border-radius: 4px;
    background: #1e8ef2;
    position: absolute;
    left: 0px;
    top: 1px;
  }
}

.file_text {
  width: 70%;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #636d7b;
  margin: 0 0 0 0;

  .file_icon {
    font-size: 18px;
    color: rgba(24, 111, 242, 1);
  }
}

.border_update {
  width: 70%;
  border-bottom: 1px solid #d9e5f4;
  margin: 11px 0 0 0;
}

.table {
  width: 70%;
}

.inp {
  width: 23vw;
}

.ml32 {
  margin-left: 32px;
}

.mb16 {
  margin-bottom: 16px;
}

.mt50 {
  margin-top: 50px;
}

.ml60 {
  margin-left: 60px;
}
</style>
